<h4 class="report-title">{{ type }}</h4>
<div class="search-wrapper">
    <mat-form-field style="width: auto; margin: 10px 15px; position: absolute; right: 15px; top: 0">
        <input matInput type="text" placeholder="Enter a search item" autocomplete="off" [(ngModel)]="searchText" (keyup)="searchResult($event)" />
        <button mat-button matPrefix mat-icon-button class="search_btn">
            <mat-icon class="serach_icon">search</mat-icon>
        </button>
    </mat-form-field>
</div>

<div class="report_box">
    <div class="row">
        <ng-container>
            <div class="col-md-12 mb-5" *ngFor="let item of reportData; let i = index">
                <div class="report_sec">
                    <div class="media d-flex">
                        <div class="check_section">
                            <mat-checkbox
                                class="example-margin checkbox-wrap"
                                [checked]="item.isSelected"
                                (change)="checkUncheckReports($event, item)"
                            ></mat-checkbox>
                        </div>
                        <div class="icon_img">
                            <img src="./assets/media/logos/Pdf-file.png" />
                        </div>
                        <div class="media_body">
                            <strong>{{ item.name }}</strong>
                        </div>
                    </div>
                </div>
            </div>
            <div *ngIf="reportData?.length === 0" class="d-flex align-items-center justify-content-center w-100 h-100">
                <p class="no-data-report">No {{ type }} reports are available to Display</p>
            </div>
        </ng-container>
    </div>
</div>
